import apiClient from '../../lib/apiClient';
import { UserInfo } from './userTypes';
import { contentStore, userInfoAtom } from '@/lib/store/Contentstore';

const userInfoQueryKey = ['userInfo'];
const fetchUserInfo: () => Promise<UserInfo> = async () => {
  const userResponse = await apiClient.fetch(location.href, `/api/userinfo`);
  const userInfo = await userResponse.json();
  contentStore.set(userInfoAtom, userInfo);
  return userInfo;
};

export const userInfoQueryOptions = {
  queryKey: userInfoQueryKey,
  queryFn: () => fetchUserInfo(),
  staleTime: 1000 * 60 * 30,
};
